import {lazy} from 'react';

const AppointmentReschedule = lazy(() => import('./AppointmentReschedule'));

export default AppointmentReschedule;
